/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  var Sage = {
    // All pages
    'common': {
      init: function() {

        /****************
        **  Carousels
        *****************/
        $('.stories-carousel,.videos-carousel,.images-carousel').each(function() {
          $(this).slick({
            rows: 0,
            dots: true,
            arrows: false,
            infinite: true,
            speed: 400,
            fade: true,
            cssEase: 'linear',
            autoplay: true,
            autoplaySpeed: 8000,
            pauseOnHover: true
          });
        });
        $('.testimonials-carousel').slick({
          rows: 0,
          dots: true,
          arrows: false,
          centerMode: true,
          centerPadding: '0px',
          variableWidth: true,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                variableWidth: true
              }
            },
            {
              breakpoint: 480,
              settings: {
                variableWidth: true
              }
            }
          ]
        });

        /****************
        **  Decrease font-size for headings inside of main content
        *****************/
        // $('.wp-block-heading').each(function() {
        //   var currentSize = parseFloat($(this).css('font-size')); // in px
        //   $(this).css('font-size', (currentSize * 0.75) + 'px');
        // });


        /****************
        **  Primary nav for mobile
        *****************/
        $('#mobile-nav-primary ul.mobile-nav li.menu-item-has-children > a').each(function() {
          $(this).append(' <i class="fa-solid fa-angle-down" aria-hidden="true"></i>');
        });
        $('#mobile-nav-primary ul.mobile-nav li.menu-item-has-children .sub-menu li.menu-item.title-only > a').on('click', function(e) {
          e.preventDefault(); // prevent parent link navigation
          return false;
        });

        $('.mobile-nav .menu-item-has-children > a').on('click', function(e) {
          e.preventDefault(); // prevent parent link navigation

          var $li = $(this).parent('li');
          var $submenu = $li.children('.sub-menu');

          if ($li.hasClass('open')) {
            $submenu.slideUp(200);
            $li.removeClass('open');
          } else {
            $submenu.slideDown(200);
            $li.addClass('open');
          }
        });
        // Append an icon to each submenu link
        $('.mobile-nav .sub-menu > li:not(.title-only) > a').each(function() {
          $(this).append(' <i class="fa-solid fa-angle-right" aria-hidden="true"></i>');
        });


        /****************
        **  Initiate Social share buttons
        *****************/
        (function(){
          socializer('.socializer');
        }());

        /****************
        **  Override socializer printfriendly link
        *****************/
        document.addEventListener('click', function(e) {
          const $link = $(e.target).closest('a[href*="printfriendly.com"]');
          if ($link.length) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            window.print();
            return false;
          }
        }, true);


        /****************
        **  Jump Menu
        *****************/
        $('select.jump-select').on('change', function () {
          var url = $(this).val();
          if (url) { window.location = url; }
          return false;
        });


        /****************
        **  Moving homepage hero figure on desktop
        *****************/
        var destinationContainer = $(".page-header.header-gallery-home .gallery-item.item1");
        var movedFigure = $(".page-header.header-gallery-home .gallery-item.item3 figure");
        $(destinationContainer).append(movedFigure);
        $(".page-header.header-gallery-home .gallery-item.item3").remove();


        /****************
        **  Closing 2 column containers when a full-width block is applied
        *****************/
        $('.columned-content').each(function () {
          var $row     = $(this);
          var $mainbar = $row.children('.mainbar');

          if (!$mainbar.length) return;

          var $fw = $mainbar.find('.wp-full-width').first();
          if (!$fw.length) return;

          if ($row.data('wpfwProcessed')) return;
          $row.data('wpfwProcessed', true);

          // Detach full-width + everything after it in mainbar
          var $afterInMain = $fw.nextAll().detach();
          $fw.detach();

          // Detach everything after the entire columned-content row
          var $afterRow = $row.nextAll().detach();

          // Create wrapped section
          var $postCols = $(
            '<section class="post-columned-content">' +
              '<div class="post-columned-main"></div>' +
            '</section>'
          );
          var $postColInner = $postCols.find('.post-columned-main');

          // Insert wrapper after columned row
          $row.after($postCols);

          // Append moved content
          $postColInner.append($fw);
          if ($afterInMain.length) $postColInner.append($afterInMain);
          if ($afterRow.length)    $postColInner.append($afterRow);

          if (!$mainbar.children().length) {
            $row.addClass('only-sidebar');
          }
        });


      },
      finalize: function() {
        // JS to be fired on all pages, after page specific JS
      }
    },

    // Home page
    'home': {
      init: function() { /* home init */ },
      finalize: function() { /* home finalize */ }
    },

    // Providers page
    'providers_list_page': {
      init: function() {

        /****************
        **  Providers page toggles
        *****************/
        var $roots = $('.provider-typeahead');
        if (!$roots.length) {
          console.warn('[typeahead] no .provider-typeahead found');
          return;
        }

        $roots.each(function (idx, el) {
          var $root  = $(el);
          var $input = $root.find('#providerSearch');
          var $box   = $root.find('#providerSearchResults');

          if (!$input.length || !$box.length) {
            console.warn('[typeahead] missing input/results in container', idx);
            return;
          }

          var endpoint = $box.data('endpoint') || '';
          if (!endpoint) {
            console.warn('[typeahead] missing data-endpoint');
            return;
          }

          var timer = null;
          var xhr   = null; // jqXHR for aborting

          function esc(s){
            return (s||'').replace(/[&<>"']/g, function(m){
              return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[m]);
            });
          }

          function highlight(label, q){
            var L = label || '', Q = q || '';
            var i = L.toLowerCase().indexOf(Q.toLowerCase());
            if (i < 0) { return esc(L); }
            // simplified highlight (no <strong>, plus arrow icon)
            return esc(L.slice(0,i)) + esc(L.slice(i,i+Q.length)) + esc(L.slice(i+Q.length)) + '<i class="fa-solid fa-arrow-right" aria-hidden="true"></i>';
          }

          function show(){
            $box.show();
            if ($box.html()) { $input.addClass('has-results'); }
          }
          function hide(){
            $box.hide();
            $input.removeClass('has-results');
          }

          function render(list){
            if (!Array.isArray(list) || list.length === 0) {
              $box.empty();
              hide();
              return;
            }
            var q = $.trim($input.val());
            var html = list.map(function(item){
              return "<a class='list-group-item list-group-item-action' href='"+esc(item.url)+"'>" +
                       "<span>"+highlight(item.title,q)+"</span>" +
                     "</a>";
            }).join('');
            $box.html(html);
            show();
            $input.addClass('has-results');
          }

          function fetchResults(q){
            if (xhr && xhr.readyState !== 4) { xhr.abort(); }
            if (!q || q.length < 2) {
              $box.empty();
              hide();
              return;
            }

            var url = endpoint + '?search=' + encodeURIComponent(q) + '&per_page=8&title_only=1';

            xhr = $.ajax({
              url: url,
              method: 'GET',
              dataType: 'json',
              xhrFields: { withCredentials: true }
            })
            .done(render)
            .fail(function(_, status){
              if (status !== 'abort') {
                hide();
              }
            });
          }

          function debounceFetch(q){
            clearTimeout(timer);
            timer = setTimeout(function(){ fetchResults(q); }, 200);
          }

          // events
          $input.on('input', function(){
            debounceFetch($.trim(this.value));
          });
          $input.on('keyup', function(e){
            if (e.key === 'Escape') { hide(); }
          });
          $input.on('search', function(){
            debounceFetch($.trim(this.value));
          });
          $input.on('focus', function(){
            if ($box.html()) { show(); }
          });

          // click-outside to close
          $(document).on('click', function(e){
            if (!$root.is(e.target) && $root.has(e.target).length === 0) {
              hide();
            }
          });

          // keep results box same width as input
          function syncWidth() {
            $box.width($input.outerWidth());
          }
          syncWidth();
          $(window).on('resize', syncWidth);
        });
      }
    },

    // Services page
    'services_list_page': {
      init: function() {

        /****************
        **  Services page toggles
        *****************/
        var $search    = $('#serviceSearchInput');
        var $select    = $('#serviceLetterFilter');
        var $form      = $search.closest('form');
        var $container = $('.services-row').first();
        var $items     = $container.find('.service-card');
        var $tallyEl   = $('p.results-tally');

        if (!$search.length || !$select.length || !$container.length || !$items.length) {
          return;
        }

        // Never submit (avoid reloads)
        if ($form.length) {
          $form.on('submit', function(e){ e.preventDefault(); });
        }

        function norm(s){
          return (s||'').toLowerCase()
            .normalize('NFD').replace(/[\u0300-\u036f]/g,'')
            .replace(/\s+/g,' ')
            .trim();
        }

        var timer = null;
        function later(fn, ms){
          clearTimeout(timer);
          timer = setTimeout(fn, ms||150);
        }

        function applyFilter(){
          var letter = ($select.val() || '').toUpperCase();
          var q      = norm($search.val());
          var active = 0;

          $items.each(function(){
            var $el = $(this);
            var matchesLetter = !letter || $el.data('letter') === letter;
            var keywords      = ($el.attr('data-keywords') || '');
            var matchesQuery  = !q || (keywords.indexOf(q) !== -1);
            var show          = matchesLetter && matchesQuery;
            $el.toggleClass('d-none', !show);
            if (show) { active++; }
          });

          // No-results message
          $container.find('p.no-results').remove();
          if (active === 0) {
            $container.append('<p class="no-results">Sorry, no services match that search.</p>');
          }

          // Tally (show only when filtering)
          var filtering = !!(letter || q);
          if ($tallyEl.length) {
            if (filtering) {
              $tallyEl.removeClass('d-none').text(active + ' result' + (active===1?'':'s') + ' showing');
            } else {
              $tallyEl.addClass('d-none').text('');
            }
          }
        }

        // Typing → reset letter to All, then filter
        $search.on('input search keyup', function(){
          if ($select.val() !== '') {
            $select.val('');
          }
          later(applyFilter, 120);
        });

        // ESC clears search immediately
        $search.on('keydown', function(e){
          if (e.key === 'Escape') {
            $search.val('');
            applyFilter();
          }
        });

        // Picking a letter → clear search, then filter
        $select.on('change', function(){
          if ($search.val() !== '') {
            $search.val('');
          }
          applyFilter();
        });

        // Initial run
        applyFilter();
      }
    },
    // Provider page
    'single_provider': {
      init: function() {

        $('#printProfile').on('click', function(e) {
          e.preventDefault();
          window.print();
        });

      }
    },
    // About us page
    'about_us': {
      init: function() { /* about init */ }
    }
  };

  // Router
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // common init
      UTIL.fire('common');

      // page-specific init + finalize
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // common finalize
      UTIL.fire('common', 'finalize');
    }
  };

  $(document).ready(UTIL.loadEvents);

})(jQuery);
